// noteNode.js

import { useState } from 'react';
import { BaseNode } from './BaseNode';

export const NoteNode = ({ id, data }) => {
    const [note, setNote] = useState(data?.note || 'Remember to connect this pipeline...');

    return (
        <BaseNode
            id={id}
            title="Sticky Note"
            handles={[]} // No handles for a note node
            style={{
                backgroundColor: '#fff9c4', // Light yellow sticky note background
                border: '1px solid #fbc02d',
                boxShadow: '2px 2px 5px rgba(0,0,0,0.1)'
            }}
        >
            <textarea
                value={note}
                onChange={(e) => setNote(e.target.value)}
                style={{
                    width: '100%',
                    minHeight: '80px',
                    border: 'none',
                    background: 'transparent',
                    resize: 'vertical',
                    fontSize: '14px',
                    outline: 'none'
                }}
            />
        </BaseNode>
    );
}
